import { alpha, styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import * as React from 'react';
import { colors } from '../../utils';

const StyledSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: colors.purple,
    '&:hover': {
      backgroundColor: alpha(colors.purple, theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: colors.lightPurple
  },
}));

export default function CustomSwitch(props) {
  return (
    <div>
      <StyledSwitch {...props}/>
    </div>
  );
}
